import { useContext, useEffect, useState } from 'react';
import type { AwsRum } from 'aws-rum-web';

import { AwsRumClientContext } from './context';
import { initializeAWSRum } from './initializeAwsRum';

export interface AWSRumProps {
    applicationIds: Record<string, string>;
    identityPoolId?: string;
    rumGuestRoleArn?: string;
}

let initialized = false;

export const useInitAwsRum = ({
    rumGuestRoleArn,
    applicationIds,
    identityPoolId,
}: AWSRumProps): AwsRum | null => {
    const [awsRum, setAwsRum] = useState<AwsRum | null>(null);

    useEffect(() => {
        if (!rumGuestRoleArn || !identityPoolId) {
            return;
        }

        const tld = (window.location.hostname.match(
            /(?:evbqa|evbstage|eventbrite)(\.\S+)$/
        ) || [])[1];
        const applicationId = tld ? applicationIds[tld] : null;

        if (!applicationId || initialized) {
            return;
        }
        const initialize = async () => {
            const awsRum = await initializeAWSRum({
                applicationId,
                identityPoolId,
                rumGuestRoleArn,
            });
            initialized = true;
            setAwsRum(awsRum);
        };

        // initializeAWSRum now handles errors internally and returns null on failure,
        // so we don't need try/catch here. The .catch() is a safeguard for any
        // unexpected errors during the initialization process.
        initialize().catch(() => {
            // Silently ignore - errors are already logged in initializeAWSRum
        });
    }, [applicationIds, identityPoolId, rumGuestRoleArn]);

    return awsRum;
};

export const useAwsRum = () => {
    const { awsRum } = useContext(AwsRumClientContext);
    return awsRum;
};

